import { HeaderSort } from "./header-sort"

// eslint-disable-next-line @typescript-eslint/no-require-imports
require("pivot-headers.less")

const PivotHeader = props => {
    let classes = props.classes ? props.classes.join(" ") : ""
    classes += " pivot-header-wide"
    return (
        <div className={`pivot-header ${classes}`} style={props.centerSubtitle ? { justifyContent: "center" } : {}}>
            <div className="pivot-header-custom-font">
                <span>
                    {props.column.colDef.headerName} {props.enableSorting ? <HeaderSort {...props} /> : null}
                </span>
            </div>
            <div className={props.subtitles.length === 3 ? "pivot-header-days-inline-wide" : "pivot-header-days-inline-wide-total"}>
                {props.subtitles.map((subtitle, index) => (
                    <div key={index} className={"pivot-header-custom-width-wide"}>
                        {subtitle}
                    </div>
                ))}
            </div>
        </div>
    )
}
export default PivotHeader
